export default __webpack_public_path__ + "static/media/tape-measure.15d5aff8.png";